export enum CarType {
  Ray = "RAY",
  Starex = "STAREX",
}

export interface Vehicle {
  vehicleName: string;
  workTimeWindow: {
    startTimeLimited: string;
    endTimeLimited: string;
  };
  car: {
    carType: CarType;
    maxCapacity: number;
  };
  startPlace: {
    placeName: string;
    road: string;
    latitude: number;
    longitude: number;
  };
  endPlace?: {
    placeName: string;
    road: string;
    latitude: number;
    longitude: number;
  };
}

export interface VehiclePayload {
  vehicleName: string;
  workTimeWindow: {
    startTimeLimited: {
      hour: string;
      minute: string;
    };
    endTimeLimited: {
      hour: string;
      minute: string;
    };
  };
  car: {
    carType: CarType;
    maxCapacity: number;
  };
  startPlace: {
    placeName: string;
    road: string;
    latitude: number;
    longitude: number;
  };
  endPlace?: {
    placeName: string;
    road: string;
    latitude: number;
    longitude: number;
  };
}
